import React, { useMemo } from "react";
import { useSortBy, useTable } from "react-table";
import {
    Button,
    Table,
} from "reactstrap";
import { useTranslate } from "react-translate";

const StudyAnalytes = ({ study }) => {
    const t = useTranslate('laboratory-detail');

    let data = useMemo(
        //|| ('Set ID - NTE' in el)
        () => Object.keys(study).length && study.medicalValues && Array.isArray(study.medicalValues) ? study.medicalValues.map(p => {
            const tableData = {
                c1: p?.['Observation Identifier'].replace(/^([\S]{1,})\s/, ""),
                c2: p?.['Observation Value'],
                c3: p?.['Units'],
                c4: p?.['References Range'],
                c5: p?.['Abnormal Flags'],
                c6: p?.['Comment'].map((commentLine, index) => {
                    return <><p key={index}>{commentLine}</p></>
                }),
            };

            return { ...tableData };

            //}

        }) : [],
        //eslint-disable-next-line
        [study]
    );

    const columns = useMemo(
        () => [
            {
                Header: `${t('observation-identifier')}`,
                accessor: "c1",
                defaultCanSort: true
            },
            {
                Header: `${t('observation-value')}`,
                accessor: "c2",
                disableSortBy: true,
            },
            {
                Header: `${t('units')}`,
                accessor: "c3",
                disableSortBy: true,
            },
            {
                Header: `${t('references-range')}`,
                accessor: "c4",
                disableSortBy: true,
            },
            {
                Header: `${t('abnormal-flags')}`,
                accessor: "c5",
                disableSortBy: true,
            },
            {
                Header: `${t('comment')}`,
                accessor: "c6",
                disableSortBy: true,
            },
        ],
        //eslint-disable-next-line
        [study]
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data, initialState: { hiddenColumns: ["c5"] } }, useSortBy);

    return (
        <>
            
            <div className="table-responsive">
                <Table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        className={`session-table-header`}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps((state, rowInfo) => {
                                    if (rowInfo && rowInfo.row) {
                                        return {
                                            style: {
                                                backgroundColor: rowInfo.row.values.c5 !== '' ? '#ffdddd' : '',
                                            },
                                            key: `tr-${i}`
                                        }
                                    } else return { key: `tr-${i}` }
                                })}
                                    
                                >
                                    {row.cells.map((cell, j) => {
                                        return (
                                            <td
                                                {...cell.getCellProps({key: `td-${j}-row-${i}`})}
                                            >
                                                {cell.render('Cell')}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default StudyAnalytes;